import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'translate';

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  background: #00b480;
  
  svg {
    height: 30px;
    margin-right: 10px;
    fill: #fff;
  }
  
  p {
    max-width: 304px;
    margin-bottom: 0;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    text-align: center;
  }
  
  @media screen and (max-width: 550px) {
    height: 45px;
    
    svg {
      height: 20px;
      margin-right: 6px;
    }
    
    p {
      max-width: 266px;
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

const ForwardRopstenHeader = ({ className, noRewards }) => window.CONFIG.mainNet !== 1 && !noRewards && (
  <StyledHeader className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 90">
      <path
        d="M99.71,80.29,55.57,3.85a5.85,5.85,0,0,0-10.14,0L1.29,80.29a5.86,5.86,0,0,0,5.08,8.79H94.64a5.86,5.86,0,0,
        0,5.07-8.79Zm-4.26,3.4a.91.91,0,0,1-.82.48H6.36a1,1,0,0,1-.81-1.42L49.68,6.31a.94.94,0,0,1,1.64,0L95.45,
        82.75A.9.9,0,0,1,95.45,83.69ZM55.33,74.55A4.54,4.54,0,1,1,50.8,70,4.53,4.53,0,0,1,55.33,74.55ZM50.8,28.11A5.88,
        5.88,0,0,1,56.66,34a6.27,6.27,0,0,1-.09,1L53.89,63.63a3.1,3.1,0,0,1-6.19,0L45,35a5.66,5.66,0,0,1-.09-1A5.88,
        5.88,0,0,1,50.8,28.11Z"
      />
    </svg>
    <p>
      <FormattedMessage id="campaign_modal.pay_forward.ropsten_warn" />
    </p>
  </StyledHeader>
);

ForwardRopstenHeader.propTypes = {
  noRewards: PropTypes.bool,
  className: PropTypes.string,
};

ForwardRopstenHeader.defaultProps = {
  className: '',
};

export default ForwardRopstenHeader;
